import * as THREE from 'three'
import GUI from 'lil-gui'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import halftoneVertexShader from './shaders/halftone/vertex.glsl'
import halftoneFragmentShader from './shaders/halftone/fragment.glsl'
import WebcamTexture from './Webcam/webcam.js'; // Import the WebcamTexture class
import { MeshBasicMaterial } from 'three';

/**
 * Base
 */
// Debug
const gui = new GUI()
gui.hide();

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const introScene = new THREE.Scene()

let activeScene = introScene;


/**
 * Loading
 */

const textureLoader = new THREE.TextureLoader();
const eventEmitter = new EventTarget();


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2)
}


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    windowAspectRatio = sizes.width/sizes.height
    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)
    
    // Update camera
    camera.left = sizes.width/-2;
    camera.right = sizes.width/2;
    camera.bottom = sizes.height/-2;
    camera.top = sizes.height/2;
    //camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(sizes.pixelRatio)

    // Scaling Background Image
    if (windowAspectRatio < BGImageAspectRatio) {
        // Scale based on height
        const scaleFactor = sizes.height / backgroundPlane.geometry.parameters.height;
        backgroundPlane.scale.set(scaleFactor, scaleFactor, 1);

        const scaleFactor2 = sizes.height / backgroundPlane2.geometry.parameters.height;
        backgroundPlane2.scale.set(scaleFactor2, scaleFactor2, 1);
    } else {
        // Scale based on width
        const scaleFactor = sizes.width / backgroundPlane.geometry.parameters.width;
        backgroundPlane.scale.set(scaleFactor, scaleFactor, 1);

        const scaleFactor2 = sizes.width / backgroundPlane2.geometry.parameters.width;
        backgroundPlane2.scale.set(scaleFactor2, scaleFactor2, 1);
    }

    //Scaling Backdrop
    const backdropScaleFactor = sizes.width / backdropPlane.geometry.parameters.width;
    //backdropPlane.scale.set(backdropScaleFactor * backdropPadding, backdropScaleFactor * backdropPadding, 1)
    group.scale.set(backdropScaleFactor * backdropPadding, backdropScaleFactor * backdropPadding, 1)

    //Scaling Intro Modal
    if (windowAspectRatio > 1){
        //Maintain the small modal
        const scaleFactor = (sizes.width / introModalPlane.geometry.parameters.width) * introModalPadding;
        introModalPlane.scale.set(scaleFactor, scaleFactor, 1);
        introButtonPlane.scale.set(scaleFactor, scaleFactor,1)

        const positionScale = scaleFactor * introModalPlane.geometry.parameters.height
        introButtonPlane.position.set(0,(-165/494)*positionScale,-.08)
        console.log(positionScale)

    } else {
        //Have it be 80% padding since its vertical
        const scaleFactor = sizes.width/introModalPlane.geometry.parameters.width *.8 ;
        introModalPlane.scale.set(scaleFactor, scaleFactor, 1);
        introButtonPlane.scale.set(scaleFactor, scaleFactor,1)

        const positionScale = scaleFactor * introModalPlane.geometry.parameters.height
        introButtonPlane.position.set(0,(-165/494)*positionScale,-.08)
        console.log(positionScale)
    }

    //Update Intro Particle Pixel Sizes 
    particleMaterial1.uniforms.uPixelRatio.value = window.devicePixelRatio;
    particleMaterial2.uniforms.uPixelRatio.value = window.devicePixelRatio;
    particleMaterial3.uniforms.uPixelRatio.value = window.devicePixelRatio;
})

/**
 * Camera
 */
// Base camera
let leftFulstrum = sizes.width/-2;
let rightFulstrum = sizes.width/2;
let bottomFulstrum = sizes.height/-2;
let topFulstrum = sizes.height/2;
const camera = new THREE.OrthographicCamera(leftFulstrum, rightFulstrum, topFulstrum, bottomFulstrum, 0.01, 8000 );
camera.position.set(0, 0, 10)
introScene.add(camera)
scene.add(camera)

//Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Camera Helper
 */
// const cameraHelper = new THREE.CameraHelper(camera);
// introScene.add(cameraHelper); // Add the helper to the scene
/**
 * Axes Helper
 */
// const axesHelper = new THREE.AxesHelper(200); // Length of the axes (e.g., 200 units)
// introScene.add(axesHelper); // Add the axes helper to the scene

/**
 * Webcam Video
 */
let activeWebcam;
let webcamTexture;
//const videoTexture = new WebcamTexture();
//activeWebcam = videoTexture
//console.log(videoTexture);

/**
 * Material
 */
const material = new THREE.ShaderMaterial({
    vertexShader: halftoneVertexShader,
    fragmentShader: halftoneFragmentShader,
    uniforms:
    {
        uTexture: { value: activeWebcam }, // Pass the video texture
        vUV: { value: new THREE.Vector2(1.0, 1.0) }, // Initialize vUV to default values
        uThreshold: { value: 0.3 }, // Initial threshold value
        uDotSize: { value: 90.0},
        uAspectRatio: {value: 16.0/9.0},
        uCircleColor: { value: new THREE.Color(0.0, 0.0, 0.0) }, // Default circle color (black)
        uBackgroundColor: { value: new THREE.Color(1.0, 1.0, 1.0) } // Default background color (white)
    }
})

gui.add(material.uniforms.uThreshold, 'value').min(0.0).max(1.0).step(.001).name('Threshold');
gui.add(material.uniforms.uDotSize, 'value').min(30.0).max(300.0).step(1.0).name('DotSize');

// Add color pickers for uCircleColor and uBackgroundColor
gui.addColor(material.uniforms.uCircleColor, 'value').name('Circle Color').onChange((value) => {
    material.uniforms.uCircleColor.value.set(value);
});

gui.addColor(material.uniforms.uBackgroundColor, 'value').name('Background Color').onChange((value) => {
    material.uniforms.uBackgroundColor.value.set(value);
});




/**
 * Background
 */

let BGImageAspectRatio; // Define a global variable to store the aspect ratio
let backgroundPlane;
let backgroundPlane2;
let backgroundMaterial;



const backgroundTexture = textureLoader.load('/PixelSkyTrial.png', function (texture){
    console.log('Texture loaded successfully!');

    BGImageAspectRatio = texture.image.width / texture.image.height;
    const BGWidth = texture.image.width
    const BGHeight = texture.image.height

    // Apply nearest-neighbor scaling for a pixelated effect
    backgroundTexture.minFilter = THREE.NearestFilter;
    backgroundTexture.magFilter = THREE.NearestFilter;
    backgroundTexture.colorSpace = THREE.SRGBColorSpace; // Correct color space

    // Create a material for the background image
    backgroundMaterial = new THREE.MeshBasicMaterial({
        map: backgroundTexture,
        depthWrite: false // Prevents the background from affecting depth buffer
    });
    
    createBackgroundPlane();
});


let windowAspectRatio;

// Helps make it reactive. 
function createBackgroundPlane() {
    windowAspectRatio = sizes.width / sizes.height;
    //console.log(windowAspectRatio)
    // Check if the window aspect ratio is greater than the background image aspect ratio
    if (windowAspectRatio < BGImageAspectRatio) {
        backgroundPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.height * BGImageAspectRatio, sizes.height), 
            backgroundMaterial,
        );
    //console.log('backgroundplaneHeight', backgroundPlane.geometry.parameters.height, 'backgroundplaneWidth', backgroundPlane.geometry.parameters.width, "yes")
    } else {
        backgroundPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.width, sizes.width / BGImageAspectRatio),
            backgroundMaterial
        );
    //console.log('backgroundplaneHeight', backgroundPlane.geometry.parameters.height, 'backgroundplaneWidth', backgroundPlane.geometry.parameters.width, "no")
    }

    // Position the background plane behind all other elements
    backgroundPlane.position.z = -2;

    //Clone it for the intro Scene
    backgroundPlane2 = backgroundPlane.clone();

    //scene.add(backgroundPlane);
    introScene.add(backgroundPlane2)
    scene.add(backgroundPlane);
}



/**
 * Backdrop
 */

let backdropAspectRatio;
let backdropPlane;
let backdropMaterial;
let sizedBackdropWidth;

let backdropPadding = .9;


const backdropTexture = textureLoader.load(
    '/BackdropCutout.png', 
    function (texture) {
        // Texture is loaded, proceed with calculations and settings
        backdropAspectRatio = texture.image.width / texture.image.height;

        // Apply nearest-neighbor scaling for a pixelated effect
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.colorSpace = THREE.SRGBColorSpace; // Correct color space

        // Create a material for the backdrop
        backdropMaterial = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,  // Renders transparent areas
            depthWrite: false   // Prevents transparent pixels from affecting depth
        });
        createBackdropPlane();
        createGroupFromBackdrop();
    },
);


// Adding Backdrop Plane. 
function createBackdropPlane() {
    if (windowAspectRatio < backdropAspectRatio) {
        // backdropPlane = new THREE.Mesh(
        //     new THREE.PlaneGeometry((sizes.height * backdropAspectRatio) * backdropScaleFactor , sizes.height * backdropScaleFactor), 
        //     backdropMaterial,
        // );
        backdropPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.width * backdropPadding, sizes.width / backdropAspectRatio * backdropPadding),
            backdropMaterial
        );
    } else {
        backdropPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.width * backdropPadding, sizes.width / backdropAspectRatio * backdropPadding),
            backdropMaterial
        );
    }
    sizedBackdropWidth = backdropPlane.geometry.parameters.width
}



let group = new THREE.Group();
let buttonGroup = new THREE.Group();
let buttons = []; // Store all buttons for interaction handling


// Shader uniforms for circle and background colors
const uniforms = {
    uCircleColor: { value: new THREE.Color(0, 0, 0) },
    uBackgroundColor: { value: new THREE.Color(0, 0, 0) },
};

// Predefined colors
const circleColors = [
    new THREE.Color(233/255, 60/255, 57/255),
    new THREE.Color(254/255, 255/255, 242/255),
    new THREE.Color(255/255, 180/255, 216/255),
    new THREE.Color(183/255, 242/255, 171/255),
    new THREE.Color(11/255, 52/255, 254/255),
    new THREE.Color(93/255, 222/255, 251/255),
    new THREE.Color(255/255, 134/255, 5/255), 
    new THREE.Color(237/255, 89/255, 126/255),
    new THREE.Color(23/255, 75/255, 62/255),
    new THREE.Color(152/255, 196/255, 134/255),        
    // Add more colors as needed
];

const backgroundColors = [
    new THREE.Color(47/255, 190/255, 251/255),
    new THREE.Color(37/255, 34/255, 27/255),
    new THREE.Color(133/255, 239/255, 244/255),
    new THREE.Color(254/255, 24/255, 46/255),
    new THREE.Color(206/255, 229/255, 225/255),
    new THREE.Color(255/255, 217/255, 54/255),
    new THREE.Color(81/255, 223/255, 175/255), 
    new THREE.Color(233/255, 139/255, 227/255),
    new THREE.Color(246/255, 197/255, 5/255),
    new THREE.Color(157/255, 81/255, 201/255),    
    // Add more colors as needed
];


// Function to create the group
function createGroupFromBackdrop() {
    if (!backdropPlane) return;

    // Get dimensions from the backdropPlane's geometry
    const backdropBounds = {
        width: backdropPlane.geometry.parameters.width,
        height: backdropPlane.geometry.parameters.height,
    };

    // Create a group and align it to the backdropPlane
    group.position.set(
        backdropPlane.position.x,
        backdropPlane.position.y,
        backdropPlane.position.z 
    );
    group.add(backdropPlane);
    introScene.add(group);
    scene.add(group)

    // Dispatch an event
    const event = new Event('groupReady');
    eventEmitter.dispatchEvent(event);
}

// Listen for the event
eventEmitter.addEventListener('groupReady', () => {
    if (!group) return;

    //createCube();
    flavorButtons();
    randomButton();
    
});


//Flavor Buttons

let buttonMaterial;

// Grid properties
const numButtons = 10;
const numColumns = 2;
let startingX; 
let startingY;


function flavorButtons() {
    for (let i = 1; i <= numButtons; i++) {
        const buttonTexture = textureLoader.load(
            `/Buttons/${i}.png`,
            function (texture) {
                // Apply nearest-neighbor scaling for a pixelated effect
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.colorSpace = THREE.SRGBColorSpace; // Correct color space
                
                //console.log(`Width of Button ${i}:`, texture.image.width);
                // Create material for each button
                buttonMaterial = new THREE.MeshBasicMaterial({
                    map: texture,
                    transparent: true, // Renders transparent areas
                    depthWrite: false, // Prevents transparent pixels from affecting depth
                });
                
                // Create and position the button
                createFlavorButton(i, buttonMaterial);
            }
        );
    }
}

function createFlavorButton(index, material) {
    const buttonSize = (sizedBackdropWidth  * (90 / 1769));
    startingX = sizedBackdropWidth * (12/1769);
    startingY = sizedBackdropWidth * (20/1769);
    const buttonPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(buttonSize, buttonSize),
        material
    );

    // Make sure the position is set properly
    const bRow = Math.floor((index - 1) / numColumns);
    const bColumn = (index - 1) % numColumns;
    //console.log(bRow)
    buttonPlane.position.set(
        bColumn === 0 ? (buttonSize) * (bColumn) : (buttonSize ) * (bColumn) + startingX,
        -((bRow * startingY) + (buttonSize * bRow)),
        1,
    );
    const chill = index - 1
    buttonPlane.userData = {
        index,
        circleColor: circleColors[chill % circleColors.length],
        backgroundColor: backgroundColors[chill % backgroundColors.length],
    };

    //console.log(buttonPlane.userData)

    // Add to group or scene
    buttonGroup.add(buttonPlane);
    buttons.push(buttonPlane); // Add to buttons array

}

positionButtonGroup();

// Position buttonGroup after sizedBackdropWidth is set
function positionButtonGroup() {
    if (sizedBackdropWidth) {
        buttonGroup.position.set(
            (sizedBackdropWidth/1769) * 701.5, 
            (sizedBackdropWidth/1769) * 92, 
            0
        );
        //console.log(sizedBackdropWidth)
    } else {
        // If sizedBackdropWidth is not yet set, wait and check again
        requestAnimationFrame(positionButtonGroup);
        //console.log('not yet')
    }
}
group.add(buttonGroup)



//Random Button
let randomButtonMaterial

function randomButton(){

    const randomButtonTexture = textureLoader.load(
        `/Buttons/randomButton.png`,
        function (texture) {
            // Apply nearest-neighbor scaling for a pixelated effect
            texture.minFilter = THREE.NearestFilter;
            texture.magFilter = THREE.NearestFilter;
            texture.colorSpace = THREE.SRGBColorSpace; // Correct color space
            
            //console.log(`Width of Button ${i}:`, texture.image.width);
            // Create material for each button
            randomButtonMaterial = new THREE.MeshBasicMaterial({
                map: texture,
                transparent: true, // Renders transparent areas
                depthWrite: false, // Prevents transparent pixels from affecting depth
            });

            const randomButtonPlane = new THREE.Mesh(
                new THREE.PlaneGeometry((sizedBackdropWidth  * (156 / 1769)), sizedBackdropWidth  * (156 / 1769), 1),
                randomButtonMaterial
            );

            randomButtonPlane.position.set(
            (sizedBackdropWidth/1769) * 752, 
            (sizedBackdropWidth/1769) * 296.5, 
            0            
            )

            randomButtonPlane.userData.index = "random"; // Unique index for random button
            group.add(randomButtonPlane);
            buttons.push(randomButtonPlane); // Add to buttons array

        }
    );
}


positionRandomButtonGroup();

// Position buttonGroup after sizedBackdropWidth is set
function positionRandomButtonGroup() {
    if (sizedBackdropWidth) {
        buttonGroup.position.set(
            (sizedBackdropWidth/1769) * 701.5, 
            (sizedBackdropWidth/1769) * 92, 
            0
        );
        //console.log(sizedBackdropWidth)
    } else {
        // If sizedBackdropWidth is not yet set, wait and check again
        requestAnimationFrame(positionRandomButtonGroup);
        //console.log('not yet')
    }
}
group.add(buttonGroup)

//Window Browse Buttons


// Initialize raycaster and mouse vector
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

// Detect clicks and swap texture
function onCanvasClick(event) {
    // Convert mouse position to normalized device coordinates
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Update the raycaster
    raycaster.setFromCamera(mouse, camera);

    // Check for intersections
    const intersects = raycaster.intersectObjects(buttons);
    if (intersects.length > 0) {
        const clickedButton = intersects[0].object;

        // Store the original texture
        const originalTexture = clickedButton.material.map;


        // Determine the appropriate texture path
        let texturePath;
        if (clickedButton.userData.index === "random") {
            // Path for the random button
            texturePath = `/Buttons_Closed/randomButtonClosed.png`; 
        console.log("Random button texture path:", texturePath);

            //Setting Random Colors 
            const colorInterval = setInterval(() => {
                // Set the color to a random value every 50 milliseconds
                material.uniforms.uCircleColor.value.set(Math.random(), Math.random(), Math.random());
                material.uniforms.uBackgroundColor.value.set(Math.random(), Math.random(), Math.random());
            }, 50); // Change color quickly to simulate carousel effect
    
            // After a short delay, stop the color cycling and set a final random color
            setTimeout(() => {
                clearInterval(colorInterval); // Stop cycling colors
    
                // Set the final random color
                material.uniforms.uCircleColor.value.set(Math.random(), Math.random(), Math.random());
                material.uniforms.uBackgroundColor.value.set(Math.random(), Math.random(), Math.random());
            }, 750); // Duration of the carousel effect in milliseconds
        }

        // Check if the clicked object is a browser button
        else if (clickedButton.userData.type === "browserButton") {
            console.log(`Browser button ${clickedButton.userData.index} clicked`);
            texturePath = `/Browser_Buttons_Closed/${clickedButton.userData.index}.png`


            // Switch scenes after 150ms
            setTimeout(() => {
                webcamTexture.stopVideo()
                activeScene = introScene;
                
                
            }, 200);
        }

        else {
            // Path for flavor buttons
            texturePath = `/Buttons_Closed/${clickedButton.userData.index}.png`;

            // console.log(`This button ${clickedButton.userData.index} was clicked`)
            // console.log(clickedButton.userData)

            // Setting Colors
            material.uniforms.uCircleColor.value.copy(clickedButton.userData.circleColor);
            material.uniforms.uBackgroundColor.value.copy(clickedButton.userData.backgroundColor);
        }

        // Load pressed state texture
        const pressedTexture = textureLoader.load(
            texturePath,
            function (texture) {
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.colorSpace = THREE.SRGBColorSpace;

                clickedButton.material.map = texture; // Update texture
                clickedButton.material.needsUpdate = true;

                // Set a timer to revert to the original texture
                setTimeout(() => {
                    clickedButton.material.map = originalTexture;
                    clickedButton.material.needsUpdate = true;
                }, 100); // Change back after 1 second

            }
        );
    }

    // Handle clicks on the introButton separately
    if (raycaster.intersectObject(introButtonPlane).length > 0) {

        // Store the original texture
        const originalTexture = introButtonPlane.material.map;

        // Path for intro button texture
        const texturePath = `/Buttons_Closed/introButtonClosed.png`;
        // Load pressed state texture
        const pressedTexture = textureLoader.load(
            texturePath,
            function (texture) {
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.colorSpace = THREE.SRGBColorSpace;

                introButtonPlane.material.map = texture; // Update texture
                introButtonPlane.material.needsUpdate = true;

                // Set a timer to revert to the original texture
                setTimeout(() => {
                    introButtonPlane.material.map = originalTexture;
                    introButtonPlane.material.needsUpdate = true;
                }, 100); // Change back after 1 second

                // Switch scenes after 200ms
                setTimeout(() => {
                    //console.log('Switching scenes...');
                    webcamTexture = new WebcamTexture();
                    activeWebcam = webcamTexture.videoTexture;

                    material.uniforms.uTexture.value = activeWebcam;
                    activeScene = scene;

                }, 200);
            }
        );
    }
}


// Ensure group is positioned
positionButtonGroup();

/**
 * Webcam Plane
 */
// Variables to control the webcam plane’s position and scale
let webcamPosition = { x: 0, y: 0, z: 0 }; // Initial position
let webcamScale = .75; // Initial scale

createWebcamPlane()

function createWebcamPlane(){
    if (sizedBackdropWidth) {
        let webcamWidth = sizedBackdropWidth * (1490/1769) ;
        let webcamHeight = webcamWidth / (16/9)
        const webcamPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(webcamWidth, webcamHeight, 10, 10),
        material
        );
        webcamPlane.position.set(-120 * (sizedBackdropWidth/1769) , -5 * (sizedBackdropWidth/1769), -.1);
        group.add(webcamPlane);
        //console.log(sizedBackdropWidth)
    } else {
        // If sizedBackdropWidth is not yet set, wait and check again
        requestAnimationFrame(createWebcamPlane);
        //console.log('not yet')
    }
}

/**
 * Browser Buttons
 */

let browserButtonMaterial;
let browserButtonGroup = new THREE.Group

// Grid properties
const numBrowserButtons = 2;

browserButtons()

function browserButtons() {
    for (let i = 0; i <= numBrowserButtons; i++) {
        const buttonTexture = textureLoader.load(
            `/Browser_Buttons/${i}.png`,
            function (texture) {
                // Apply nearest-neighbor scaling for a pixelated effect
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.colorSpace = THREE.SRGBColorSpace; // Correct color space
                
                //console.log(`Width of Button ${i}:`, texture.image.width);
                // Create material for each button
                browserButtonMaterial = new THREE.MeshBasicMaterial({
                    map: texture,
                    transparent: true, // Renders transparent areas
                    depthWrite: false, // Prevents transparent pixels from affecting depth
                });

                //console.log(`yes, ${i}`)
                // Create and position the button
                createBrowserButton(i, browserButtonMaterial);
            }
        );
    }
}

let buttonSize
function createBrowserButton(index, material) {

    if (!sizedBackdropWidth || sizedBackdropWidth <= 0) {
        requestAnimationFrame(browserButtons); // Retry when the browser is ready
        return;
    }

    buttonSize = (sizedBackdropWidth  * (25 / 1769));
    const numBrowserSpacing = ((10)*(sizedBackdropWidth/1769)+buttonSize);
    //console.log(index)
    const browserButtonPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(buttonSize, buttonSize),
        material
    );
    browserButtonPlane.position.set(
        numBrowserSpacing * index,
        0,
        1,
    );
    // Add userData for identification
    browserButtonPlane.userData = {
        index: index,
        type: "browserButton", // Tag buttons for specific handling
    };

    // Add to group or scene
    browserButtonGroup.add(browserButtonPlane);
    buttons.push(browserButtonPlane); // Add to buttons array
    
    positionBrowserButtonGroup();

}

// Position buttonGroup after sizedBackdropWidth is set
function positionBrowserButtonGroup() {
    if (sizedBackdropWidth) {
        browserButtonGroup.position.set(
            -840 * (sizedBackdropWidth/1769), 
            397 * (sizedBackdropWidth/1769), 
            -.1
        );
    } else {
        // If sizedBackdropWidth is not yet set, wait and check again
        requestAnimationFrame(positionBrowserButtonGroup);
    }
    group.add(browserButtonGroup)
}


/**
 * Intro Scene 
 */
 

// Create the particle system
const particleCount = 24;
const particlesGeometry = new THREE.BufferGeometry();
const positions = new Float32Array(particleCount * 3); // x, y, z for each particle
const speeds = new Float32Array(particleCount); // Array to store individual speeds
const windIntensity = new Float32Array(particleCount); // Wind pushing particles to the left

// Initialize particle positions
for (let i = 0; i < particleCount; i++) {
    positions[i * 3] = Math.random() * sizes.width - (sizes.width/2) + 50; // x: -sized.width/2 to sized.width/2
    positions[i * 3 + 1] =  Math.random() * (2 * sizes.height) - sizes.height; // y:
    positions[i * 3 + 2] =  -1; // z: -1 to -3

    speeds[i] = .3 + (Math.random()*.8); // Random fall speed between 0.3 and 0.8
    windIntensity[i] = -.05 + Math.random() * -.2 // Random Wind to the left between -.05 to -2.5

}
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));


/**
 * Particles Material
 */
// Array of image URLs
const iconSet1 = Math.floor(Math.random() * 3) + 1
const iconSet2 = Math.floor(Math.random() * 3) + 5
const iconSet3 = Math.floor(Math.random() * 3) + 8

const imageUrls = [
    `/Icons/${iconSet1}.png`,
    `/Icons/${iconSet2}.png`,
    `/Icons/${iconSet3}.png`,
];

// console.log(imageUrls)

// Load textures
const loader = new THREE.TextureLoader();
const textures1 = [loader.load(imageUrls[0])];
const textures2 = [loader.load(imageUrls[1])];
const textures3 = [loader.load(imageUrls[2])];

// Create a custom shader material 1
const particleMaterial1 = new THREE.ShaderMaterial({
    uniforms: {
        uTextures: { value: textures1 },
        uTime: { value: 0.0 },
        uSize: {value: 100.0},
        uPixelRatio: { value: window.devicePixelRatio } // Add device pixel ratio
    },
    vertexShader: `
        attribute float aTextureIndex;
        varying float vTextureIndex;
        uniform float uSize;
        uniform float uPixelRatio;

        void main() {
            vTextureIndex = aTextureIndex;
            gl_PointSize = uSize * uPixelRatio;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform sampler2D uTextures[1];
        varying float vTextureIndex;

        void main() {
            int index = int(vTextureIndex);
            vec4 color = texture2D(uTextures[0], gl_PointCoord);
            if (color.a < 0.1) discard; // Make transparent edges invisible
            gl_FragColor = color;
        }
    `,
    transparent: true
});

// Create a custom shader material 2
const particleMaterial2 = new THREE.ShaderMaterial({
    uniforms: {
        uTextures: { value: textures2 },
        uTime: { value: 0.0 },
        uSize: {value: 100.0},
        uPixelRatio: { value: window.devicePixelRatio } // Add device pixel ratio
    },
    vertexShader: `
        attribute float aTextureIndex;
        varying float vTextureIndex;
        uniform float uSize;
        uniform float uPixelRatio;


        void main() {
            vTextureIndex = aTextureIndex;
            gl_PointSize = uSize * uPixelRatio;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform sampler2D uTextures[1];
        varying float vTextureIndex;

        void main() {
            int index = int(vTextureIndex);
            vec4 color = texture2D(uTextures[0], gl_PointCoord);
            if (color.a < 0.1) discard; // Make transparent edges invisible
            gl_FragColor = color;
        }
    `,
    transparent: true
});

// Create a custom shader material 3
const particleMaterial3 = new THREE.ShaderMaterial({
    uniforms: {
        uTextures: { value: textures3 },
        uTime: { value: 0.0 },
        uSize: {value: 100.0},
        uPixelRatio: { value: window.devicePixelRatio } // Add device pixel ratio
    },
    vertexShader: `
        attribute float aTextureIndex;
        varying float vTextureIndex;
        uniform float uSize;
        uniform float uPixelRatio;


        void main() {
            vTextureIndex = aTextureIndex;
            gl_PointSize = uSize * uPixelRatio;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform sampler2D uTextures[1];
        varying float vTextureIndex;

        void main() {
            int index = int(vTextureIndex);
            vec4 color = texture2D(uTextures[0], gl_PointCoord);
            if (color.a < 0.1) discard; // Make transparent edges invisible
            gl_FragColor = color;
        }
    `,
    transparent: true
});

//Particle Groups 
var particleMaterialIndex = [
    particleMaterial1,
    particleMaterial2,
    particleMaterial3,
]

//One Place to set Particle Size
const particleSize = 100 ;
particleMaterial1.uniforms.uSize.value = particleSize;
particleMaterial2.uniforms.uSize.value = particleSize;
particleMaterial3.uniforms.uSize.value = particleSize;

// Using groups TEST
particlesGeometry.clearGroups(); // Ensure no residual groups exist
particlesGeometry.addGroup(0, 8, 0); // First 5 points, materialIndex 0
particlesGeometry.addGroup(8, 8, 1); // Next 5 points, materialIndex 1
particlesGeometry.addGroup(16, 8, 2); // Next 5 points, materialIndex 1

const points = new THREE.Points(particlesGeometry, particleMaterialIndex);
points.frustumCulled = false;

introScene.add(points)


/**
 * Intro Scene Modal
 */


let introModalAspectRatio;
let introModalPlane;
let introModalMaterial;
let introModalPadding = 769/1920;

//Intro Button 
let introButtonMaterial
let introButtonPlane
let introButtonAspectRatio;
let introButtonPadding = 516/1920;

//The Modal Material
const introModalTexture = textureLoader.load(
    '/IntroModal.png', 
    function (texture) {
        // Texture is loaded, proceed with calculations and settings
        introModalAspectRatio = texture.image.width / texture.image.height;

        // Apply nearest-neighbor scaling for a pixelated effect
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.colorSpace = THREE.SRGBColorSpace; // Correct color space

        // Create a material for the backdrop
        introModalMaterial = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,  // Renders transparent areas
            depthWrite: false   // Prevents transparent pixels from affecting depth
        });
        createIntroModalTexture();

    },
);

//The Modal Button Material
function createIntroModalTexture(){

    const introButtonTexture = textureLoader.load(
    `/Buttons/introButton.png`,
    function (texture) {
        introButtonAspectRatio = texture.image.width / texture.image.height;

        // Apply nearest-neighbor scaling for a pixelated effect
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.colorSpace = THREE.SRGBColorSpace; // Correct color space
        
        //console.log(`Width of Button ${i}:`, texture.image.width);
        // Create material for each button
        introButtonMaterial = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true, // Renders transparent areas
            depthWrite: false, // Prevents transparent pixels from affecting depth
        });
        createIntroModalPlane();
    }
);

}

// Adding Intro Modal Plane. 
function createIntroModalPlane() {
    if (windowAspectRatio < 1) {
        introModalPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.width * .8, sizes.width / introModalAspectRatio * .8),
            introModalMaterial
        );

        introButtonPlane = new THREE.Mesh(
            new THREE.PlaneGeometry((introModalPlane.geometry.parameters.width)*(516/764), (introModalPlane.geometry.parameters.width)*(516/764)/introButtonAspectRatio),
            introButtonMaterial
        );
    } else {
        introModalPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(sizes.width * introModalPadding, sizes.width / introModalAspectRatio * introModalPadding),
            introModalMaterial
        );

        introButtonPlane = new THREE.Mesh(
            new THREE.PlaneGeometry((introModalPlane.geometry.parameters.width)*(516/764), (introModalPlane.geometry.parameters.width)*(516/764)/introButtonAspectRatio),
            introButtonMaterial
        );
    }
    introModalPlane.position.set(0,0, -.1)
    introButtonPlane.position.set(0,(-165/494)*introModalPlane.geometry.parameters.height,-.08)
    introScene.add(introModalPlane)
    introScene.add(introButtonPlane)
}


/**
 * Renderer
 */
const rendererParameters = {}
rendererParameters.clearColor = '#ffffff'

const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setClearColor(rendererParameters.clearColor)
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(sizes.pixelRatio)

// Attach event listener Canvas Click
renderer.domElement.addEventListener('click', onCanvasClick);

gui
    .addColor(rendererParameters, 'clearColor')
    .onChange(() =>
    {
        renderer.setClearColor(rendererParameters.clearColor)
    })

/**
 * Animate
 */
const clock = new THREE.Clock()
clock.start()

let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime; // Time difference since the last frame
    previousTime = elapsedTime; // Update previous time


    const positions = particlesGeometry.attributes.position.array;
    for(let i = 0; i < particleCount; i++)
    {

        positions[i * 3 + 1] -= speeds[i] * deltaTime * 60  ;   // Move Y position down
        //console.log(deltaTime)
        positions[i * 3] += windIntensity[i] * deltaTime * 50; // Add wind to X position (leftward movement)


        // Reset particles if they fall below a certain point
        if (positions[i * 3 + 1] < -(sizes.height/2 + 50)) {

            positions[i * 3] = Math.random() * sizes.width - (sizes.width/2) + (sizes.width * .1); // x: -sized.width/2 to sized.width/2
            positions[i * 3 + 1] =  (sizes.height*.8);
            positions[i * 3 + 2] = -1 ; // z: -1 to -3
        
            speeds[i] = .3 + (Math.random()*.8); // Random fall speed between 0.3 and 0.8
            windIntensity[i] = -.05 + Math.random() * -.2 // Random Wind to the left between -.05 to -2.5
            
        }
        
    }
    particlesGeometry.attributes.position.needsUpdate = true 


    // Update controls
    // controls.update()


    // Render
    renderer.render(activeScene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

